import "./CsApp.scss";
import { FC, useEffect, useMemo } from "react";
import { Grid } from "@mui/material";
import ErrorBoundary from "./ErrorBoundary";
import { NativeBridge } from "./features/Feature_Native/NativeBridgeComp";
import ErrorComp from "./components/CustomError/ErrorComp";
import Loading from "./pages/Utilities/Loading";
import IdleTimeOut from "./pages/IdleTimeOut/IdleTimeOut";
import GenerateSsoOld from "./features/Feature_SSO/OldSSO/GenerateSsoOld";
import useGtmBaseLogic from "./features/Feature_Gtm/useGtmBaseLogic";
import CustomServiceDownTimePopUp from "./components/CustomServiceDownTimePopUp/CustomServiceDownTimePopUp";
import CustomAppDownTimePopUp from "./components/CustomAppDownTimePopUp/CustomAppDownTimePopUp";
import { useAppSelector } from "./redux-store/CustomReduxHooks";
import useCleverTapComp from "./features/Feature_CleverTap/CleverTapComp";
import AppRoutes from "./routes/AppRoutes";
import useCsAppBootstrapContext from "./hooks/useCsAppBootstrapContext";
import useCsAppCmsBootstrapData from "./hooks/useCsAppCmsBootstrapData";
import useCsAppNavbar from "./hooks/useCsAppNavbar";

const CsApp: FC = () => {
  useCleverTapComp();
  useGtmBaseLogic();

  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const generalAppElementsSlice = useAppSelector(
    (state) => state.GeneralAppElementsSlice,
  );

  const isSuperApp = useMemo(
    () => csAppSlice.channel === "SUPER APP",
    [csAppSlice.channel],
  );
  const masterData = generalAppElementsSlice.masterData;

  useCsAppBootstrapContext();

  useCsAppCmsBootstrapData();

  const {
    pathname,
    navbar,
    isHomeRoute,
    isL2RevampRoutes,
    isHLL3RevampRoutes,
    isMFL3RevampRoutes,
    isHIL3RevampRoutes,
    isLIL3RevampRoutes,
  } = useCsAppNavbar();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);

  return (
    <>
      <ErrorBoundary>
        {navbar}
        <NativeBridge />
        <Grid
          container
          spacing={3}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={
              isHomeRoute ||
              isL2RevampRoutes ||
              isHLL3RevampRoutes ||
              isMFL3RevampRoutes ||
              isHIL3RevampRoutes ||
              isLIL3RevampRoutes
                ? 12
                : 6
            }
            className={isSuperApp ? "no-tap-highlights" : ""}
          >
            <AppRoutes />
          </Grid>
        </Grid>
        <ErrorComp />
        <CustomServiceDownTimePopUp />
        <GenerateSsoOld key={"generateSSOOLD_Comp"} />
        <Loading />
        <IdleTimeOut />
        {masterData?.masterDetail?.["servicing-app-status"] &&
          masterData.masterDetail["servicing-app-status"].length > 0 &&
          masterData.masterDetail["servicing-app-status"][0]?.masterValue ===
            "true" && <CustomAppDownTimePopUp onClick={() => {}} open={true} />}
      </ErrorBoundary>
    </>
  );
};

export default CsApp;
